import { Injectable, OnDestroy, inject } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';

import { AnalyticsService } from 'ngx-shared-services';
import { UserService } from './user.service';

export enum MixPanelEvent {
  APPLICATION_NAME = 'HomePage',
  VIEW_HOME_PAGE = 'View HomePage',
  CLICK_GO_ACTIVE_DISPATCHES = 'HomePage.DispSch_ADLink',
  CLICK_GO_COM = 'HomePage.COM_link',
  CLICK_GO_TRENDS = 'HomePage.Trends_link',
  CLICK_GO_CTA = 'HomePage.CTA_link',
  ACTION_WEATHER_LOCATION = 'HomePage.weather_location',
  DROPDOWN_DEMAND = 'HomePage.Demand_dropdown',
  DROPDOWN_ERP = 'HomePage.ERP_dropdown',
}

@Injectable({
  providedIn: 'root',
})
export class MixPanelService implements OnDestroy {
  private readonly analyticsService = inject(AnalyticsService);
  private readonly userService = inject(UserService);
  private readonly destroy$ = new Subject<void>();

  isInitialized = false;

  constructor() {
    this.registerApp();
  }

  private registerApp() {
    if (!this.isInitialized) {
      this.userService
        .getUserId()
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (userId) => {
            this.analyticsService.init(userId, MixPanelEvent.APPLICATION_NAME);
            this.analyticsService.setPage(MixPanelEvent.APPLICATION_NAME);
            this.isInitialized = true;
            this.viewHomePage();
          },
          error: (error) => {
            console.error('Error loading user:', error);
          },
        });
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  viewHomePage(): void {
    if (!this.isInitialized) {
      return;
    }
    this.analyticsService.pushEvent(MixPanelEvent.VIEW_HOME_PAGE, {
      application: MixPanelEvent.APPLICATION_NAME,
    });
  }

  trackEvent(event: MixPanelEvent, properties: Record<string, unknown> = {}): void {
    if (!this.isInitialized) {
      return;
    }

    this.analyticsService.pushEvent(event, properties);
  }
}
